import styled from '@emotion/styled';
// eslint-disable-next-line no-restricted-imports
import { Tabs } from '@workday/canvas-kit-react/tabs';
import { WcpStyles } from '@workday/wcp-tokens';
import React from 'react';

const ThemedTabsItem = styled(Tabs.Item)({
  color: WcpStyles.color.text.hint,
  ':hover': {
    color: WcpStyles.color.text.default,
    backgroundColor: WcpStyles.color.bg.alt.default,
  },
  '&[aria-selected=true]': {
    color: WcpStyles.color.text.primary.default,
    ':hover': {
      color: WcpStyles.color.text.primary.default,
    },
  },
});

const ThemedTabsList = styled(Tabs.List)({
  borderBottomColor: WcpStyles.color.border.divider,
});

export const ThemedTabs = (props: React.ComponentProps<typeof Tabs>) => <Tabs {...props} />;
ThemedTabs.List = ThemedTabsList;
ThemedTabs.Panel = Tabs.Panel;
ThemedTabs.Item = ThemedTabsItem;
ThemedTabs.OverflowButton = Tabs.OverflowButton;
ThemedTabs.Menu = Tabs.Menu;
